import React from "react";
import { browserHistory, Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import Tooltip from "../tooltip/tooltip";
import util from "../util/util";

const jQuery = window.jQuery;

export default function CampaignDetailCampaign({ campaign, rules }) {
  let hasRules = !!(rules && rules.length);
  let tooltipMessage = "Only campaigns without rules can be deleted.";

  const deleteCampaign = () => {
    const title = `Delete Campaign`;
    const body = `<p>Are you sure you want to delete the campaign: <strong>${campaign.name}</strong>?</p>`;
    const buttonTextDefault = `Delete Campaign`;
    const buttonTextLoading = `Deleting Campaign`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .deleteCampaign(campaign.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(d => {
          // once done, go back to the list of campaigns
          $modal.modal(`hide`);
          browserHistory.push(`/campaigns/`);
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-6 col-sm-8">
          <h4 className="page__title">{campaign.name}</h4>
        </div>
        <div className="col-xs-6 col-sm-4">
          <p className="page__actions">
            <Link
              to={util.returnCampaignFormUrl(campaign.id)}
              className="btn btn-primary"
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
              Edit Campaign
            </Link>
            <span
              data-tip={hasRules ? tooltipMessage : ""}
              data-for="deleteCampaign"
            >
              <button
                className="btn btn-danger"
                onClick={
                  hasRules
                    ? () => {
                        return "";
                      }
                    : () => deleteCampaign()
                }
                disabled={hasRules ? true : ""}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i>
                Delete Campaign
              </button>
            </span>
          </p>
          {hasRules && <Tooltip id="deleteCampaign" />}
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-sm-6">
          <h4 className="page__header">Campaign Name</h4>
          <p>{campaign.name}</p>
        </div>
        <div className="col-sm-6">
          <h4 className="page__header">Created</h4>
          <p>{moment(campaign.created).format(util.dateFormatHumanLong)}</p>
        </div>
      </div>
      &nbsp;
      <div className="row">
        <div className="col-sm-6">
          <h4 className="page__header">Last Changed By</h4>
          <p>
            <em>Not available in the API (yet).</em>
          </p>
        </div>
        <div className="col-sm-6">
          <h4 className="page__header">Change Log</h4>
          <p>
            <Link
              to={util.returnChangeLogDetailUrl(
                `campaigns.campaign`,
                campaign.id
              )}
            >
              View Change Log
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

CampaignDetailCampaign.propTypes = {
  campaign: PropTypes.object
};
